export const PackingMethodIdMap = Object.freeze({
	Boxes: '0',
	Pallet: '1',
});

export const FormatedCarrierMapping = Object.freeze({
	usps: 'USPS',
	ups: 'UPS',
	fedex: 'FedEx',
	dhl_ecommerce: 'DHL eCommerce',
	other: 'Other',
});
